import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {arrayIsSet, GlobalVariablesService, Links, stringIsSet} from "../../providers/service/global-variables.service";
import {animateText} from "../../animation/textAnimation"
import {NavigationEnd, Router} from "@angular/router";
import {filter, map} from "rxjs/operators";
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {PagePermission, PermissionType} from "../../ParseClass/user-permissions-parse";

@Component({
    selector: 'app-huna-container-outPage',
    templateUrl: './huna-container-outPage.component.html',
    styleUrls: ['./huna-container-outPage.component.scss'],
    animations: [animateText],
    standalone: false
})
export class HunaContainerOutPageComponent implements OnInit, OnChanges {
    @Input() currentUrl: string = '';
    @Input() disabledMenu: boolean = false;
    @Input() showSidenav: boolean|undefined|null = false;
    @Input() isTest: boolean = false;

    public links = Links
    projectRoles$: Observable<string[] | undefined>
    userRoles$: Observable<string[] | undefined>
    projectPermissions$: Observable<PagePermission[] | undefined>
    currentLink: string | undefined;
    classTitleLink = 'not-show';
    classHunaLogo = 'huna-logo-size-S';
    private subscriptions = new Subscription();
    public notificationsNotReadedInProject$: Observable<boolean>
    private selectGroupEmit = new BehaviorSubject(undefined)
    public selectGroup$: Observable<any> = this.selectGroupEmit.asObservable()
    public borderStyleGroup$: Observable<any | undefined>
    isSystemAdmin$ = this.globalVariable.isSystemAdmin$

    constructor(private globalVariable: GlobalVariablesService,
                private router: Router,
    ) {
        this.projectRoles$ = this.globalVariable.projectRoles$
        this.userRoles$ = this.globalVariable.userRoles$
        this.projectPermissions$ = this.globalVariable.permissionInProject$
        this.borderStyleGroup$ = this.selectGroup$.pipe(
            map(selectGroup => {
                if (selectGroup && selectGroup.links != null) {
                    return {'border-right': '1px solid black'}
                } else {
                    return
                }
            })
        )
        this.subscriptions.add(
            router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe(event => {
                this.currentLink = event.url
            })
        )

        this.notificationsNotReadedInProject$ = this.globalVariable.notificationsNotReadedInProject$;

    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.currentUrl != null) {
            const disableButtonUrls = ['/project']
            if (disableButtonUrls.includes(this.currentUrl)) {
                this.disabledMenu = true;
                // this.disabledProject = true;
            } else {
                this.disabledMenu = false;
                // this.disabledProject = false;
            }
        }
    }

    openSidenav() {
        this.classTitleLink = 'show';
        this.classHunaLogo = 'huna-logo-size-L';
    }

    setSelectGroup(group: any) {
        this.selectGroup = group
    }

    closeSidenav() {
        if (this.classTitleLink != 'not-show') {
            this.classTitleLink = 'not-show';
        }
        this.classHunaLogo = 'huna-logo-size-S';
        this.selectGroup = undefined

    }


    getUrlLogo() {
        if (this.classTitleLink == 'not-show') {
            return this.globalVariable.getLogoAppUrl()
        } else {
            return this.globalVariable.getLogoPcUrl()
        }
    }

    get nameProject() {
        if (this.classTitleLink == 'not-show') {
            return this.globalVariable.currentProjectSigla;
        } else {
            return this.globalVariable.currentProject?.name;
        }
    }

    private get selectGroup() {
        return this.selectGroupEmit.value
    }

    private set selectGroup(value) {
        this.selectGroupEmit.next(value)
    }

    groupContainEqualLinkPredicate(group: any, current: any): boolean {
        if (stringIsSet(current)) {
            let block = arrayIsSet(group.links) ? group.links.some((link: any) => link.path == current) : false
            return block ? block : group.path == current
        } else {
            return false
        }
    }

    isEqualLinkPredicate(link: any, current: any): boolean {
        if (stringIsSet(current)) {
            return current == link.path
        } else {
            return false
        }
    }

    filterLinkPredicate(links: any[], projectPermissions: PagePermission[] | undefined) {
        if (arrayIsSet(links)) {
            return links
                .filter((link) => {
                    let permissionToAccess = !arrayIsSet(link.pageType)
                    if (!permissionToAccess && arrayIsSet(projectPermissions)) {
                        permissionToAccess = projectPermissions.some(p =>
                            link.pageType.includes(p.page) && p.permission != PermissionType.NONE)
                    }
                    return permissionToAccess;
                })

        }
        return links
    }

    getGroupsLinkPredicate(links: any[], projectPermissions: PagePermission[] | undefined) {
        if (arrayIsSet(links)) {
            const groups= links
                .sort((linkA, linkB) => {
                    const sortA = linkA.group ? linkA.group.sortingNumber : 0
                    const sortB = linkB.group ? linkB.group.sortingNumber : 0
                    return sortA - sortB
                })
                .filter((link) => {
                    let permissionToAccess = !arrayIsSet(link.pageType)
                    if (!permissionToAccess && arrayIsSet(projectPermissions)) {
                        permissionToAccess = projectPermissions.some(p =>
                            link.pageType.includes(p.page) && p.permission != PermissionType.NONE)
                    }
                    return permissionToAccess;
                })
                .reduce((groups, link, i, self) => {
                    const groupId = link.group ? link.group.id : undefined
                    const index = groups.findIndex((group: any) => groupId && group.group.id == groupId)
                    if (index < 0) {
                        groups.push({
                            group: link.group,
                            icon: link.group.icon,
                            iconCustom: link.group.iconCustom,
                            links: [link]
                        })
                    } else {
                        groups[index].links.push(link)
                    }
                    if (i == (self.length - 1)) {
                        groups = groups.map((group: any) => {
                            if (group.links && group.links.length == 1) {
                                group['icon'] = group.links[0].icon
                                group['iconCustom'] = group.links[0].iconCustom
                                group['title'] = group.links[0].title
                                group['path'] = group.links[0].path
                                delete group.links

                            }
                            return group
                        })
                    }
                    return groups
                }, [] as {
                    icon?: string,
                    svgIcon?: string,
                    path?: string,
                    title?: string,
                    links?: { title: string, path: string, icon?: string, iconCustom?: string }[]
                }[])
            return groups
        }

        return links
    }

    getColorIconNotificationsPredicate(link: any, toRead: boolean): undefined | 'warn' {
        if (link && link.path == '/notifications' && toRead) {
            return 'warn'
        }
        return undefined
    }

    goTo(url: string) {
        if (url) {
            this.router.navigate([url])
        }
    }
}
